<ng-container *ngIf="filteredPatients.length; else noItems">
    <mat-list>
        <ng-container *ngFor="let group of filteredPatients">
            <ng-container *ngIf="group.items.length">
                <div class="list-header">{{group.date | date: 'longDate'}}</div>
                <mat-list-item *ngFor="let procedure of group.items"
                    (click)="navigateToPatientFile(procedure.Patient.id)" class="auto-height"
                    [appPatientActive]="procedure.Patient.id" [appPatientValidationStatus]="procedure.Patient"
                    #valStatus="appPatientValidationStatus">
                    <div class="patient-item">
                        <div class="patient-details">
                            <app-patient-validation-messages [valStatus]="valStatus"></app-patient-validation-messages>
                            <div matLine class="patient-name">
                                <b>{{ procedure.Patient.surname }}, {{ procedure.Patient.name }}</b>
                                <span class="patient-number" *ngIf="procedure.Patient.patientNumber">({{
                                    procedure.Patient.patientNumber
                                    }})</span>
                            </div>
                            <div matLine class="patient-diagnosis">
                                <span>{{ procedure.Patient.diagnosis }}</span>
                            </div>
                            <div matLine *ngIf="procedure.Patient.diagnosis2" class="patient-secondary-diagnosis">
                                <span>{{ buildDiagnosisString(procedure.Patient) }}</span>
                            </div>
                            <div matLine class="patient-secondary-diagnosis">
                                <span>{{ procedure.title }}</span>
                            </div>
                        </div>
                        <div class="view-icon">
                            <mat-icon>visibility</mat-icon>
                        </div>
                    </div>
                </mat-list-item>
            </ng-container>
        </ng-container>
        <div class="mobile-spacer"></div>

    </mat-list>
</ng-container>

<ng-template #noItems>
    <p class="no-records-message">No procedures found.</p>
</ng-template>